import { atom } from 'jotai';

export const paginationAtom = atom<any[]>([]);

export const tableFilterAtom = atom<any[]>([]);